module.exports = __webpack_public_path__ + "img/gansumj.52c7ae31.png";